module.exports = __webpack_public_path__ + "img/danabijak.284f42b5.png";